export default __webpack_public_path__ + "static/media/No2Open.57a0d40e.jpg";